import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './IndicatorListItem.module.scss';

export interface IndicatorListItemProps {
  isFocused: boolean;
  matchedEntity?: { name_short: string };
  item: { name: { english: string } };
  onFocus?: (name: string) => void;
  logoNode: ReactNode;
}

export const IndicatorListItem = ({
  isFocused,
  matchedEntity,
  item,
  onFocus,
  logoNode,
}: IndicatorListItemProps) => {
  return (
    <button
      className={clsx(styles.indicatorItem, {
        [styles.focused]: isFocused,
      })}
      data-testid={`list-item-${item.name.english}`}
      onFocus={() => onFocus?.(item.name.english)}
    >
      <p className={styles.indicatorText}>{item.name.english}</p>
      <div className={styles.secondary}>
        {logoNode}
        {matchedEntity && (
          <p className={styles.indicatorSmallText}>
            {matchedEntity.name_short}
          </p>
        )}
      </div>
    </button>
  );
};
